import React from 'react';

import {
  styled,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Typography,
} from '@gogame/components';
import { FormField, withFormFieldGroupFormField } from '@gogame/form';

const StyledCell = styled(TableCell)`
  padding: 0px !important;
`;
const StyledCheckbox = styled(FormField.Checkbox)`
  width: fit-content;
`;

const EMAIL = 1;
const SYSTEM = 2;
const SLACK = 3;

const order = [EMAIL, SLACK, SYSTEM];

const EventRow = withFormFieldGroupFormField()(({ hasError, item }) => {
  let eventTitle = item.name;
  if (item.required) {
    eventTitle = eventTitle + ' *';
  }

  return (
    <TableRow>
      <TableCell>
        <Typography color={hasError && 'error'}>{eventTitle}</Typography>
        {item.description?.length ? (
          <Typography color={'textSecondary'} variant={'caption'}>
            {item.description}
          </Typography>
        ) : null}
        {item.required ? (
          <Typography
            color={hasError ? 'error' : 'textSecondary'}
            variant={'caption'}
          >
            At least 1 required
          </Typography>
        ) : null}
      </TableCell>
      {order.map((id) => {
        const channel = item.channels.find((c) => c.id === id);
        const index = item.channels.findIndex((c) => c.id === id);
        if (channel && !isNaN(index)) {
          const { enabled } = channel;

          return <ChannelCell name={`channels.${index}`} enabled={enabled} />;
        }
        return null;
      })}
    </TableRow>
  );
});

const ChannelCell = withFormFieldGroupFormField()(({ enabled }) => (
  <StyledCell align={'left'} width={'74px'}>
    <StyledCheckbox name={`checked`} padding={'0'} disabled={!enabled} />
  </StyledCell>
));

const EventGroupTable = ({ data, name, eventError }) => {
  return (
    <TableContainer>
      <Table width={'100%'}>
        <TableHead style={{ zIndex: 1 }}>
          <TableRow>
            <TableCell>Event</TableCell>
            <TableCell width={'74px'}>Email</TableCell>
            <TableCell width={'74px'}>Slack</TableCell>
            <TableCell width={'74px'}>System</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item, i) => {
            const eventName = `${name}.${i}`;
            return (
              <EventRow
                key={i}
                name={eventName}
                hasError={eventError?.[i]}
                item={item}
                data={data}
              />
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default EventGroupTable;
